import styled from 'styled-components';

import { FlexRow, OCButton } from 'common/styles/oc-styled-components';
import { BREAKPOINTS } from 'common/styles/style-constants';

export const VerticallyCentered = styled(FlexRow)`
  * {
    margin-top: auto;
    margin-bottom: auto;
  }
`;

export const ViewButton = styled(OCButton)`
  && {
    height: auto;
  }
  width: 140px;

  @media (max-width: ${BREAKPOINTS.mobileMax}px) {
    && {
      border-radius: 100%;
      height: 50px;
    }

    width: 50px;
  }
`;
